import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

const DashboardText = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                textAlign: 'center',
                py: 4,
                px: 2,
            }}
        >
            {/* Main Headline with Gradient */}
            <Typography
                variant="h3"
                component="h1"
                sx={{
                    fontWeight: 'bold',
                    fontSize: { xs: '1.75rem', sm: '2.25rem', md: '2.5rem' },
                    background: 'linear-gradient(135deg, #00d4ff, #0099ff)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    mb: 2,
                    letterSpacing: '-0.025em',
                    lineHeight: 1.3,        // increase from default
                    pb: '4px',              // padding-bottom saves descenders
                    px: '2px',              // padding-sides save italic/bold edges
                }}
            >
                Your Next Big Opportunity is Waiting
            </Typography>

            {/* Subtitle */}
            <Typography
                variant="body1"
                sx={{
                    color: theme.palette.text.secondary,
                    fontSize: { xs: '1rem', sm: '1.125rem' },
                    maxWidth: '600px',
                    mx: 'auto',
                    lineHeight: 1.6,
                    fontWeight: 400,
                }}
            >
                Monitor congressional trades, insider moves, advanced screeners, portfolio tracking, financial analytics, and market alerts.
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    color: theme.palette.text.secondary,
                    fontSize: { xs: '1rem', sm: '1.125rem' },
                    maxWidth: '600px',
                    mx: 'auto',
                    lineHeight: 1.6,
                    fontWeight: 400,
                }}
            >
                Never miss another opportunity again.
            </Typography>
        </Box>
    );
};

export default DashboardText;